function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { CSS_VARIABLES as t } from "./index.es15.js";

var f = {
  triangleOffset: {}
},
    o = function o(_ref) {
  var _r$triangleOffset, _ref2;

  var _ref$offset = _ref.offset,
      r = _ref$offset === void 0 ? f : _ref$offset;
  var e = (_r$triangleOffset = r === null || r === void 0 ? void 0 : r.triangleOffset) !== null && _r$triangleOffset !== void 0 ? _r$triangleOffset : f.triangleOffset;
  return _ref2 = {}, _defineProperty(_ref2, t.transform, r.transform), _defineProperty(_ref2, t.top, r.top), _defineProperty(_ref2, t.left, r.left), _defineProperty(_ref2, t.right, r.right), _defineProperty(_ref2, t.bottom, r.bottom), _defineProperty(_ref2, t.triangleOffset.transform, e.transform), _defineProperty(_ref2, t.triangleOffset.top, e.top), _defineProperty(_ref2, t.triangleOffset.left, e.left), _defineProperty(_ref2, t.triangleOffset.right, e.right), _defineProperty(_ref2, t.triangleOffset.bottom, e.bottom), _ref2;
};

export { o as createInlineStyles };